import brand from '../brand';

class URLConfig {

   // Backend for the active client (src/clients/<id>/brand.json → apiBaseUrl).
   // For local development, set REACT_APP_API_URL in .env.development.local (gitignored, npm start only),
   // e.g. REACT_APP_API_URL=http://localhost:8080
   getBasePath() {
      return process.env.REACT_APP_API_URL || brand.apiBaseUrl;
   }

}
export default new URLConfig()
